// Shared filter and DataTable types
export enum FilterOperation {
  EQUAL = "equal",
  CONTAINS = "contains",
  IN = "in",
  GTE = "gte",
  LTE = "lte",
  OR = "or",
  STARTSWITH = "startswith",
}

export enum FilterType {
  STRING = "string",
  DATE = "date",
  NUMBER = "number",
  BOOLEAN = "boolean",
}

export interface BackendFilter {
  operation: FilterOperation;
  value: string;
  type: FilterType;
}

export interface BackendSort {
  field: string;
  order: "asc" | "desc";
}

export interface FilterSettingDto {
  filters: Record<string, BackendFilter>;
  sort: BackendSort[];
  pagination: { page: number; pageSize: number };
}

export interface DataTableApiConfig {
  endpoint: string;
  filterConfig: Array<{ key: string; type: string }>;
}
